import { tsv } from "@faire/slate/lib/tsv";
import { OverflowVariant } from "@faire/slate/private/shared/types";
import React from "react";

type IProps = React.HTMLAttributes<HTMLDivElement> & {
  /**
   * Controls the overflow behavior of the children.
   *
   * @default "scroll"
   */
  overflow?: OverflowVariant;
};

export const OverflowLayout: React.FC<IProps> = ({
  children,
  className,
  overflow,
  ...props
}) => (
  <div {...props} className={itemGroupStyle.cls({ className, overflow })}>
    {children}
  </div>
);

const itemGroupStyle = tsv({
  base: "flex",
  variants: {
    overflow: {
      scroll: "overflow-x-auto",
      wrap: "flex-wrap",
    },
  },
});
